var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Skins/BoardGraphicBoxes/index.js";
import React from 'react';

const BoardGraphicBoxes = () => /*#__PURE__*/React.createElement("g", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 4,
    columnNumber: 34
  }
});

export default BoardGraphicBoxes;
